import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { Handler } from "@store/Modules/client-framework/HandlerCreator";

export type SetSubstituteIdsParameter = {
    productIds: string[];
};

export const DispatchSubstituteProductIds: Handler<SetSubstituteIdsParameter> = props => {
    props.dispatch({
        type: "Components/SubstituteProducts/SetProductIds",
        productIds: props.parameter.productIds,
    });
};

export const chain = [DispatchSubstituteProductIds];

const setSubstituteProductIds = createHandlerChainRunner(chain, "SetSubstituteProductIds");
export default setSubstituteProductIds;
